import { CommitteesByRelatedProfileSearchDto } from './dto/committees-by-related-profile-search.dto';
import { PagedSearch } from '../../shared/model/paged-search.model';
import { Injectable } from '@angular/core';
import { ApiService, PagedResultGeneric } from 'src/app/shared';
import { CommitteeDto } from './dto/committee.dto';
import { CommitteeMemberSearchDto } from './dto/committee-member-search.dto';
import { CommitteeMemberDto } from './dto/committee-member.dto';
import { CommitteeMemberBulkAddDto } from './dto/committee-member-bulk-add.dto';

@Injectable({
  providedIn: 'root',
})
export class CommitteeMemberService {
  constructor(private _apiService: ApiService) {}

  search(dto: CommitteeMemberSearchDto): Promise<PagedResultGeneric<CommitteeMemberDto>> {
    return this._apiService.post('CommitteeMembers/Search', dto);
  }

  searchExportToCsv(dto: CommitteeMemberSearchDto): Promise<string> {
    return this._apiService.post('CommitteeMembers/Search/Export', dto);
  }

  bulkDeactivateCommitteeMembers(dto: CommitteeMemberSearchDto): Promise<string> {
    return this._apiService.post('CommitteeMembers/BulkDeactivate', dto);
  }

  bulkAddCommitteeMembers(dto: CommitteeMemberBulkAddDto): Promise<void> {
    return this._apiService.post('CommitteeMembers/BulkAdd', dto);
  }

  get(id: number, forceRefresh?: boolean): Promise<CommitteeMemberDto> {
    const cacheOptions = forceRefresh ? this._apiService.getDefaultApiCacheOptionsForNoCache() : null;
    return this._apiService.get(`CommitteeMember/${id}`, cacheOptions);
  }

  create(dto: CommitteeMemberDto): Promise<number> {
    return this._apiService.post('CommitteeMembers', dto);
  }

  update(dto: CommitteeMemberDto): Promise<void> {
    return this._apiService.put(`CommitteeMember/${dto.CommitteeID}`, dto);
  }

  delete(id: number) {
    return this._apiService.delete(`CommitteeMember/${id}`);
  }

  committeesByRelatedProfileMembers(search: CommitteesByRelatedProfileSearchDto) {
    return this._apiService.post('CommitteeMember/ByRelatedProfile/Search', search);
  }
}
